import React from "react";
import { Grid, SvgIcon, Typography } from "@material-ui/core";
import { COLORS } from "../config/theme/baseTheme";
import verifiedIcon from "../assets/icons/verified-icon.svg";
import copyIcon from "../assets/icons/copy-icon.svg";
import { useStyles } from "./ClubedConsignments.styles";
import {ReactComponent as clubbedIcon} from "../assets/icons/clubbed_icon.svg";

interface ClubbedConsignmentsProps {
  assignedConsignments: string[];
  copiedId: string | null;
  setCopiedId: (id: string | null) => void;
  defaultConsignmentId?: string;
  className?: string;
}

const ClubbedConsignments: React.FC<ClubbedConsignmentsProps> = ({ assignedConsignments, copiedId, setCopiedId, className, defaultConsignmentId }) => {
    const classes = useStyles();
 
    const handleCopy = (id: string) => {
    navigator.clipboard.writeText(id).then(() => {
      setCopiedId(id);
      setTimeout(() => setCopiedId(null), 2000); // Reset after 2 seconds
    });
  };
  const filteredConsignments = assignedConsignments.filter(
    (id) => id !== defaultConsignmentId
  );
  return (
    <Grid container className={`${classes.container} ${className || ""}`}>
    <Grid container className={classes.deliveryDetails}>
    <Grid className="editIcon" item style={{display: 'inline-flex', alignItems: 'center'}}>
    <SvgIcon
            className="icon"
            component={clubbedIcon}
            viewBox="0 0 30 17"
          />
    </Grid>
      <Typography className={classes.label}>Clubbed with</Typography>
      <Typography className={classes.consignmentText}>Consignment:</Typography>
      <Typography className={classes.consignmentText}>
        {filteredConsignments?.map((id, index) => (
          <span
            key={id}
            className={classes.consignmentItem}
            onClick={() => handleCopy(id)}
          >
            {id}
            <img
              src={copiedId === id ? verifiedIcon : copyIcon}
              alt={copiedId === id ? "verified-icon" : "copy-icon"}
              className={classes.icon}
            />
            {index < filteredConsignments.length - 1 && ", "}
          </span>
        ))}
      </Typography>
    </Grid>
  </Grid>
  );
};

export default ClubbedConsignments;